import { mapGetters } from "vuex";
import EventBus from "@/AppEventBus";

export default {
    computed: {
        ...mapGetters("global", ["mostrandoAlerta"]),
    },
    methods: {
        mostrarAlerta(alertaOpciones) {
            EventBus.emit("mostrar-alerta", alertaOpciones);
        },
    },
}